/* eslint-disable react/jsx-props-no-spreading */
import cx from 'classnames';
import { DropdownButton as BSDropdownButton, MenuItem } from 'react-bootstrap';
import type { FunctionComponent } from 'react';
import type { DropdownButtonProps, MenuItemProps } from 'react-bootstrap';

import { BUTTON_SIZE } from '../Button';
import NotificationDot from '../NotificationDot';

import './DropdownButton.less';

//  We don't want to support EVERY button size (with custom CSS). We can add them later if we actually need them.
type DropdownButtonSize = 'small' | 'medium' | 'large';

type DropdownItemStyle = 'normal' | 'danger';

//  These are props we declare on top of BS' props.
type CustomProps = {
  size?: DropdownButtonSize;
  //  Escape-hatch for custom CSS classes
  className?: string;
  //  Should the dropdown stretch the full width of the parent
  isFullWidth?: boolean;
  //  Should include a notification dot.
  hasNotificationDot?: boolean;
  //  Optional test ID to be added to the wrapper div
  testId?: string;
};

type CustomMenuItemProps = MenuItemProps & {
  type?: DropdownItemStyle;
};

type BSDropdownProps = Omit<DropdownButtonProps, 'size' | 'sizes'>;

type DropdownButtonType = FunctionComponent<BSDropdownProps & CustomProps> & {
  Item: FunctionComponent<CustomMenuItemProps>;
};

const DropdownMenuItem: FunctionComponent<CustomMenuItemProps> = ({
  type = 'regular',
  ...props
}) => <MenuItem className={cx({ danger: type === 'danger' })} {...props} />;

/**
 * FOSSA wrapper around the react-bootstrap DropdownButton.
 * Makes it look more like FOSSA branding.
 */
const DropdownButton: DropdownButtonType = ({
  children,
  size = BUTTON_SIZE.MEDIUM,
  className,
  isFullWidth,
  hasNotificationDot,
  testId,
  ...props
}) => (
  <div
    className={cx('fossa-dropdown-button', `fossa-dropdown-button--size-${size}`, {
      'fossa-dropdown-button--full-width': isFullWidth,
    }, className)}
    data-test-id={testId}
  >
    <BSDropdownButton {...props}>
      {children}
    </BSDropdownButton>
    {hasNotificationDot && <NotificationDot />}
  </div>
);

DropdownButton.Item = DropdownMenuItem;

export default DropdownButton;
